
            import tailwindConfig from "@/../tailwind.config.js";
            import "https://esm.sh/tailwindcss-cdn@3";
            tailwind.config = tailwindConfig;
          